import { render } from "./Prerender.vue?vue&type=template&id=55f8e951"
import script from "./Prerender.vue?vue&type=script&lang=js"
export * from "./Prerender.vue?vue&type=script&lang=js"
script.render = render

export default script